import { ApiMypageMyLevelInfo } from 'api/Mypage';
import { runPopupOrder } from 'utils/Common';
import Header from 'component/common/header/Header';
import Footer from 'component/common/footer/Footer';

import SubNav from "component/common/nav/SubNav";

import style from '../style/Mypage.module.scss';

import img_rating_label_normal from 'assets/images/rating_label_normal.svg';
import img_rating_label_vip from 'assets/images/rating_label_vip.svg';
import img_rating_label_vip_silver from 'assets/images/rating_label_vipSilver.svg';
import img_rating_label_vip_gold from 'assets/images/rating_label_vipGold.svg';
import img_rating_label_rvip from 'assets/images/rating_label_rVip.svg';
import { useEffect, useState } from 'react';


function getImgLevel(level){
    switch(level){
        default:
        case "normal": return img_rating_label_normal;
        case "vip": return img_rating_label_vip;
        case "vip silver":
        case "silver": return img_rating_label_vip_silver;
        case "vip gold":
        case "gold": return img_rating_label_vip_gold;
        case "rvip": return img_rating_label_rvip;
    }
}


function BenefitClose(){

    const [benefit, setBenefit] = useState(null);

    const benefitSubmit = ApiMypageMyLevelInfo({
        onSuccess:(data)=>{
            if(data?.status === true){
                setBenefit(data?.result);
            }
        },
        onError:(e)=>{

        }
    });

    useEffect(()=>{
        benefitSubmit();
    },[]);


    if(benefit === null){
        return (
            <></>
        )
    }

    return (
        <>
            <Header useMobile={false} pcTop={"-64px"}/>
            <SubNav 
                name={"등급별 혜택 안내"}
                usePc={true} 
                useMobile={true} 
                usePcRightBtns={true}
                useBtnPrev={true}
                useBtnPcPrev={true}
                useBtnHome={false}

                setTop={'0px'} 
                setPcTop={'0px'} 
                />
            {/* <!-- container --> */}
            <div id="container">
                <section className={"myBenefit wrapper " + style['myBenefit'] + " " + style['wrapper'] + " " + style['section']}>
                    
                    <div className={"my_benefit section " + style['my_benefit']} >
                        
                        <div className={"grade_up top_con radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{backgroundColor:"#eee"}}>
                            <div className={"left " + style['left']}>
                                <p className="title title-01-m-long color-txt-02">
                                    2025년 12월 1일부터 쿠폰충전 중단과 함께 등급별 혜택제도가 종료됩니다.<br />
                                    <br />
                                    미사용 잔여쿠폰 환불은 2026년 9월 1일부터 신청 가능하고,
                                    콘텐츠 구매가 필요하신 분은 1:1문의를 이용하시기 바랍니다.    
                                </p>
                            </div>
                            <div className={"right " + style['right']}>
                                {/* <button 
                                    type="button" 
                                    className="button btn_01 medium label_on filled medium radius-full"
                                    onClick={runPopupOrder}
                                    ><span className="white-always txt btn-03">충전하기</span></button> */}
                            </div>
                        </div>
                    </div>
                    
                </section>
            </div>
            {/* <!-- container --> */}

            <Footer />
        </>
    );
}




export default BenefitClose;